import resonate_png from ".././assets/resonate.png";
import makingfriends_png from ".././assets/makingfriends.png";
import whoopi_png from ".././assets/whoopi.png";
import popup_gif from ".././assets/popup.gif";
import bigtake_png from ".././assets/bigtake.png";
import hov_png from ".././assets/hov.png";
import group_chat_gif from ".././assets/group-chat.gif";
import iheart_png from ".././assets/iheart.png";
import aida_laugh_gif from ".././assets/aida-laugh.gif";
import afterlives_png from ".././assets/afterlives.png"
import aunties_gif from ".././assets/aunties.gif";
import wiz_png from ".././assets/wiz.png";

export const carouselData = [
{
    id: "resonate",
    image: resonate_png,
    title: "Just Send Me A Voice Memo",
    source: "Resonate",
    subtitle: "A live audio piece about how sound keeps us going: from an ancestral horn used by Jamaican Maroons to voice memos between friends. Commissioned by the Resonate Podcast Festival.",
    url: "https://www.resonatepodfest.com/the-pod-fest",
},
{
    id: "wiz",
    image: wiz_png,
    title: "We're Doing The Wiz",
    source: "Radiotopia",
    subtitle: "I story-edited this 2025 Tribeca Official Selection podcast by Ian Coss and Sakina Ibrahim about high school theater, racial reckonings and who gets to tell which stories.",
    url: "https://podcasts.apple.com/us/podcast/radiotopia-presents-were-doing-the-wiz/id1260747339",
},
{
    id: "popup",
    image: popup_gif,
    title: "Pop-Up Magazine",
    source: "BAM, Lincoln Center",
    subtitle: "For several years, I produced, directed and co-hosted Pop-Up Magazine, a touring 'live magazine' that brought stories to life on stage with an orchestra and visuals.",
    url: "https://www.mcdbooks.com/electric_eel/issue-026",
},
{
    id: "whoopi",
    image: whoopi_png,
    title: "Grams",
    source: "AudioFlux",
    subtitle: "An audio piece about magic mushrooms that I made as part of the inaugural cohort of Audio Flux. Featured in Richmond's Institute for Contemporary Art and the Tribeca Festival.",
    url: "https://podcasts.apple.com/us/podcast/grams-by-aaron-edwards/id1846422537?i=1000738488139",
},
{
    id: "makingfriends",
    image: makingfriends_png,
    title: "Making friends",
    source: "Slate",
    subtitle: "A lot of my work deals with connection, friendship and the ways we develop a sense of self. I wrote this essay about building community after moving to a small town.",
    url: "https://slate.com/advice/2024/09/how-to-make-friends-adult-common-advice-moving.html",
},
{
    id: "bigtake",
    image: bigtake_png,
    title: "The Big Take",
    source: "Bloomberg",
    subtitle:
      "I'm currently a part-time story editor for Bloomberg's daily narrative podcast that features in-depth, original reporting and interviews.",
    url: "https://podcasts.apple.com/us/podcast/influencers-fueled-zyns-rise-could-the-attention-backfire/id1578096201?i=1000685361449",
  },
  {
    id: "unread",
    image: iheart_png,
    title: "Unread",
    source: "iHeart",
    subtitle:
      "I story-edited this New York Magazine Best Of 2021 honorable mention by Chris Stedman about friendship, mental health, loss and the things we leave behind.",
    url: "https://podcasts.apple.com/us/podcast/unread/id1568341860",
  },
  {
    id: "group_chat",
    image: group_chat_gif,
    title: "Long live the group chat",
    source: "The Outline",
    subtitle:
      "As a founding editor of The Outline, I spearheaded special projects that melded design, text and visuals (this works best on desktop). I also hosted a daily podcast.",
    url: "https://theoutline.com/post/2315/long-live-the-group-chat",
  },
  {
    id: "hov",
    image: hov_png,
    title: "The Book of Hov",
    source: "Roc Nation",
    subtitle: "I wrote and directed audio stories, narrated by Angie Martinez, for JAY-Z's tribute exhibition at The Brooklyn Public Library.",
    url: "https://www.thebookofhov.com/1-introduction",
  },
  {
    id: "laugh_aida",
    image: aida_laugh_gif,
    title: "How to laugh when nothing is funny",
    source: "Pop-Up Magazine",
    subtitle:
      "An at-home short about Black humor that I produced and directed, starring Aida Osman (HBO Max's Rap Sh!t).",
    url: "https://www.youtube.com/watch?v=4wGoFgu0leY",
  },
  {
    id: "aunties",
    image: aunties_gif,
    title: "The enduring power of aunties",
    source: "The Outline",
    subtitle:
      "A project I created that combined prose, poetry and illustration to reflect on the role of aunts in our lives.",
    url: "https://theoutline.com/post/2547/the-enduring-power-of-aunties",
  },
];
